import { render, staticRenderFns } from "./ChatAnswerSheet.vue?vue&type=template&id=0bff43d7&scoped=true"
import script from "./ChatAnswerSheet.vue?vue&type=script&lang=js"
export * from "./ChatAnswerSheet.vue?vue&type=script&lang=js"
import style0 from "./ChatAnswerSheet.vue?vue&type=style&index=0&id=0bff43d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bff43d7",
  null
  
)

export default component.exports